import moment, { DATE_FORMAT } from '@/utils/moment-wrapper';

export function buildItemSeenEverFilterString ({ field }) {
    return `${field}.count>0`;
}

export function buildItemNotSeenEverFilterString ({ field }) {
    return `${field}.count<=0`;
}

export function buildItemSeenWithinLastFilterString ({ field, count, granularity }) {
    return `${field}.lastUsed>=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}")`;
}

export function buildItemSeenNotWithinLastFilterString ({ field, count, granularity }) {
    return `(${field}.lastUsed>=now()||${field}.lastUsed<=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}"))`;
}

export function buildItemSeenSinceFilterString ({ field, value }) {
    const date = moment(value, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `${field}.lastUsed>=date("${date}")`;
}

export function buildItemSeenBeforeFilterString ({ field, value }) {
    const date = moment(value, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `${field}.lastUsed<=date("${date}")`;
}

export function buildItemSeenBetweenFilterString ({ field, first, last }) {
    const formattedFirst = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);
    const formattedLast = moment(last, { ignoreTimeZone: true })
        .add(1, 'days')
        .format(DATE_FORMAT.iso);

    return `(${field}.lastUsed>=date("${formattedFirst}")&&${field}.lastUsed<date("${formattedLast}"))`;
}

export function buildItemSeenAtMostFilterString ({ field, value }) {
    return `${field}.count<=${value}`;
}

export function buildItemSeenAtLeastFilterString ({ field, value }) {
    return `${field}.count>=${value}`;
}

export function parseCounterFilterPipeline ({ fact, used, ...params }) {
    let filterString;

    switch (fact) {
        case 'used':
            filterString = buildItemSeenEverFilterString(params);
            switch (used) {
                case 'since':
                    filterString += `&&${buildItemSeenSinceFilterString(params)}`;
                    break;
                case 'withinLast':
                    filterString += `&&${buildItemSeenWithinLastFilterString(params)}`;
                    break;
                case 'atleast':
                    filterString = buildItemSeenAtLeastFilterString(params);
                    break;
                case 'atmost':
                    filterString = buildItemSeenAtMostFilterString(params);
                    break;
                // default 'ever'; nothing appended
            }
            break;
        case 'lastused':
            filterString = buildItemSeenEverFilterString(params);
            switch (used) {
                case 'before':
                    filterString += `&&${buildItemSeenBeforeFilterString(params)}`;
                    break;
                case 'since':
                    filterString += `&&${buildItemSeenSinceFilterString(params)}`;
                    break;
                case 'withinLast':
                    filterString += `&&${buildItemSeenWithinLastFilterString(params)}`;
                    break;
                case '!withinLast':
                    filterString += `&&${buildItemSeenNotWithinLastFilterString(params)}`;
                    break;
                case 'between':
                    filterString = buildItemSeenBetweenFilterString(params);
                    break;
            }
            break;
        case 'notused':
            filterString = buildItemNotSeenEverFilterString(params);
            switch (used) {
                case 'since':
                    filterString += `||!(${buildItemSeenSinceFilterString(params)})`;
                    break;
                case 'withinLast':
                    filterString += `||!(${buildItemSeenWithinLastFilterString(params)})`;
                    break;
                // default 'ever'; nothing appended
            }
            break;
    }

    return { filter: filterString };
}
